/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { replacePXinStringWithEM, pxToEm, imageTypes, overlay, disable } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : IMAGE PANE : YOUR OWN : STYLES --------------- ++++++++++ */
export default theme => ({
	yourown: {
		'& .imageupload': {
			width: '47%',
            position: 'relative',
			borderRadius: pxToEm(4),
			marginRight: pxToEm(8),
			marginBottom: pxToEm(8),
			'&.active-true':{
				width: '100%'
			}
		},
		'& .imagedisplay': {
				backgroundColor: theme.color.neutral.light.swatch,
				border: 'solid',
				borderColor: theme.color.neutral.medium.swatch,
				borderWidth: pxToEm(1),
				borderRadius: pxToEm(2),
                extend: [imageTypes.photo, overlay],
                backgroundSize: 'cover',
                cursor: 'pointer',
                width: '100%',
                height: pxToEm(138),
                zIndex: '1',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				'& .imageInput': {
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center',
					justifyContent: 'center',
					fontSize: pxToEm(14),
					position: 'absolute',
					height: '100%',
					width: '100%',
					color: theme.color.neutral.medium.swatch,
					background: theme.color.light.light.swatch,
                    border: `dashed ${pxToEm(4)} ${theme.color.neutral.light.swatch}`,
				},
				'& img': {
					width: pxToEm(35),
					height: pxToEm(45),
				}
			},
			'& .uploadingimage-true':{
				'& .inner':{
					extend: disable
				}
			},
			'& .cropperSlider':{
                border: replacePXinStringWithEM(`1px solid ${theme.color.neutral.light.swatch}`),
				padding:pxToEm(5),
				boxShadow: theme.boxShadow.small
			},
			'& .mainImageInput': {
				top: 0,
				left: 0,
				margin: pxToEm(-4),
				width: '100%',
				height: '100%',
				opacity: "0",
				overflow: 'hidden',
				position: 'absolute',
				zIndex: "3",
				cursor: 'pointer'
			},
			'& .cropperTitle': {
				fontSize: pxToEm(12),
				textAlign: 'center',
				marginBottom:pxToEm(5)
			}
		}
});
